<template>
  <div v-if="!loading">
    <h1 class="title font-weight-regular">
      Prehľad zmien IAPSZ:
    </h1>
    <v-data-iterator
      :items="prehlad_zmien"
      hide-default-footer
    >
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="(item, index) in props.items"
            :key="index"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
              <v-card-title class="subheading font-weight-bold">
                {{
                  item.date
                }}
              </v-card-title>

              <v-divider />

              <v-list dense>
                <v-list-item>
                  <v-list-item-content>
                    <strong>Používateľ:</strong>
                  </v-list-item-content>
                  <v-list-item-content class="align-end">
                    <strong>{{ item.user }}</strong>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>
                    <strong>Časť:</strong>
                  </v-list-item-content>
                  <v-list-item-content class="align-end">
                    <strong>{{ item.model }}</strong>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item
                  v-for="(field, index2) in item.fields"
                  :key="index2"
                >
                  <v-list-item-content>{{ field.name }}:</v-list-item-content>
                  <v-list-item-content
                    class="align-end"
                  >
                    {{ field.old }} -> {{ field.new }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>

  <div v-else>
    <form-skeleton-component
      skeleton_type="PrehladZmien"
    />
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api';
import { useRoute } from '@/composables/useRouter.js';
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
  },

  setup() {
    const route = useRoute();
    const loading = ref(false);
    const prehlad_zmien = ref([]);

    const getItem = () => {
      loading.value = true;
      apiService
        .getIapszPrehladZmien(route.params.id)
        .then((response) => {
          prehlad_zmien.value = response;
          loading.value = false;
        });
    };

    onMounted(() => {
      getItem();
    });

    return {
      loading,
      prehlad_zmien,
    };
  },
};
</script>